export const Role = {
    Admin: 'admin',
    Patient: 'patient',
    Clinic: 'clinic',
    Dev: 'dev',
    Demo: 'demo',
}
